import { Route, Routes } from "react-router";

import { AdminRoute, ProtectedRoute } from "@/components/protected-route";
import { AdminActivityPage } from "@/features/admin/activity";
import { AdminHouseholdsPage } from "@/features/admin/households";
import { AdminHouseholdDetailPage } from "@/features/admin/households/household-detail";
import { KitSheetPage } from "@/features/admin/households/kit-sheet";
import { AdminUsersPage } from "@/features/admin/users";
import { HomePage } from "@/features/home";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { OnboardingPage } from "@/features/onboarding";
import { PreviewPage } from "@/features/preview";
import { ProfilePage } from "@/features/profile";
import { SignupPage } from "@/features/signup";
import { SplashPage } from "@/features/splash";
import { VerifyEmailPage } from "@/features/verify-email";
import { WifiLinkPage } from "@/features/wifi-link";

export function App() {
  return (
    <Routes>
      {/* Public landing: surfaces the two entry routes (onboarding + admin). */}
      <Route path="/" element={<SplashPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      {/* Public: unauthenticated visitors must see the email-entry screen,
          not be redirected to the staff /login. */}
      <Route path="/onboarding" element={<OnboardingPage />} />
      {/* Public: a household opens this from a link Viktoria sends. The token
          in the URL is the only credential; no session is involved. */}
      <Route path="/wifi/:token" element={<WifiLinkPage />} />
      {/* Dev-only screen gallery for design review: every onboarding screen at
          every stage, with stub data and no hardware. `import.meta.env.DEV` is
          statically false in a production build, so the route and its module
          are dropped at build time. */}
      {import.meta.env.DEV && <Route path="/preview" element={<PreviewPage />} />}
      <Route element={<ProtectedRoute />}>
        <Route path="/home" element={<HomePage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>
      <Route element={<AdminRoute />}>
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/activity" element={<AdminActivityPage />} />
        <Route path="/admin/households" element={<AdminHouseholdsPage />} />
        <Route path="/admin/households/:id" element={<AdminHouseholdDetailPage />} />
        <Route path="/admin/households/:id/kit-sheet" element={<KitSheetPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
